module.exports = __webpack_public_path__ + "static/media/WechatIMG48.3180141d.jpeg";